import React from 'react';
import {FederatedButton, Icon, Label} from 'app/components/authProvider/buttons/sharedStyles';
import ButtonSkeleton from 'app/components/authProvider/buttons/ButtonSkeleton';

export default function GoogleButton({onClick, initialized}) {
  if (!initialized) {
    return <ButtonSkeleton />;
  }

  return (
    <FederatedButton tabIndex='1' onClick={onClick}>
      <Icon src='google_logo.svg' width={20} height={20} alt='google' />
      <Label color={'rgba(0, 0, 0, .54)'}>Mit Google fortfahren</Label>
    </FederatedButton>
  );
}
